'use client'

import { useEffect, useRef, useState } from 'react'
import Script from 'next/script'
import styles from './Accessibility.module.scss'

function findEqualWebButton(): HTMLElement | null {
  return (
    document.getElementById('INDmenu-btn') ??
    document.getElementById('AccessibilityLauncher') ??
    document.getElementById('interdeal-btn') ??
    document.querySelector<HTMLElement>('.INDrounded-btn')
  )
}

export function Accessibility() {
  const [scriptLoaded, setScriptLoaded] = useState(false)
  const pollRef = useRef<ReturnType<typeof setInterval> | null>(null)

  useEffect(() => () => { if (pollRef.current) clearInterval(pollRef.current) }, [])

  const handleClick = () => {
    // Widget ya inicializado → abrir directamente
    const btn = findEqualWebButton()
    if (btn) { btn.click(); return }

    // Primer click: cargar el script
    if (!scriptLoaded) setScriptLoaded(true)

    // Evitar múltiples loops si el usuario pulsa varias veces mientras carga
    if (pollRef.current) return

    // Esperar a que EqualWeb cree su botón (máx ~4.5 s)
    let attempts = 0
    pollRef.current = setInterval(() => {
      const btn = findEqualWebButton()
      if (btn) {
        btn.click()
        clearInterval(pollRef.current!)
        pollRef.current = null
      } else if (++attempts >= 30) {
        clearInterval(pollRef.current!)
        pollRef.current = null
      }
    }, 150)
  }

  return (
    <div className={styles.container}>
      <div className={styles.buttonWrapper}>
        <button
          type="button"
          className={styles.trigger}
          onClick={handleClick}
          aria-label="Abrir menú de accesibilidad"
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            className={styles.logo}
            src="/entradas/icons/icon_accessibility.svg"
            alt=""
            width={24}
            height={24}
          />
        </button>

        {scriptLoaded && (
          <Script type="text/javascript" id="equalweb-widget-script" strategy="afterInteractive">
            {`
              window.interdeal = {
                sitekey: "de41b54822e07050564940435999a899",
                Position: "Right",
                Menulang: "ES",
                domains: { js: "https://cdn.equalweb.com/", acc: "https://access.equalweb.com/" },
                btnStyle: {
                  vPosition: ["100%", "100%"],
                  scale: ["0.6", "0.6"],
                  color: { main: "#242424", second: "#ffffff" },
                  icon: { type: 11, shape: "rounded", outline: false }
                }
              };
              (function(a,c,b){
                a = a.createElement("script");
                a.src = interdeal.domains.js + "core/4.4.1/accessibility.js";
                a.defer = !0;
                a.integrity = "sha512-tq2wb4PBHqpUqBTfTG32Sl7oexERId9xGHX2O3yF91IYLII2OwM1gJVBXGbEPaLmfSQrIE+uAOzNOuEUZHHM+g\x3d\x3d";
                a.crossOrigin = "anonymous";
                a.setAttribute("data-cfasync", !0);
                b ? b.appendChild(a) : c.appendChild(a);
              })(document, document.head, document.body);
            `}
          </Script>
        )}
      </div>
    </div>
  )
}
